export class ObjectNames {
    static text = {name: 'text', icon: 'text-box-custom'};
    static shape = {name: 'shape', icon: 'polygon-custom'};
    static sticker = {name: 'sticker', icon: 'sticker-custom'};
    static drawing = {name: 'drawing', icon: 'pencil-custom'};
    static image = {name: 'image', icon: 'photo-library'};
    static mainImage = {name: 'mainImage', icon: 'photo-library'};
}

